import { render } from "./Form.vue?vue&type=template&id=2b7b0aae&scoped=true"
import script from "./Form.vue?vue&type=script&lang=js"
export * from "./Form.vue?vue&type=script&lang=js"

import "./Form.vue?vue&type=style&index=0&id=2b7b0aae&lang=scss"
import "./Form.vue?vue&type=style&index=1&id=2b7b0aae&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b7b0aae"]])

export default __exports__